/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-no-useless-fragment */
import qs from 'query-string';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { convertToPhilippinesTime } from '../../../AppUtil/AppUtil';
import LoanService from '../../../Service/LoanService';
import Table from '../../Common/Table';
import { hot } from 'react-hot-loader';

class Loans extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_customFilterQuery:
				this.props.status == 'ALL'
					? `state=PENDING,DECLINE,DELETED,APPROVE,POST_MODIFIED,PRE_MODIFIED,COMPLETED,PAYMENTS_STOPED`
					: '',
			isOpen: false,
			modalContent: null
		};
	}

	handleClick = ({ src }) => {
		if (src.includes('.pdf')) {
			// Create the modal div
			const modal = document.createElement('div');
			modal.id = 'modal';
			modal.style.zIndex = '1000';
			modal.style.position = 'fixed';
			modal.style.top = '0';
			modal.style.left = '0';
			modal.style.width = '100%';
			modal.style.height = '100%';
			modal.style.background = 'rgba(0,0,0,0.8)';
			modal.style.display = 'flex';
			modal.style.alignItems = 'center';
			modal.style.justifyContent = 'center';
			modal.style.cursor = 'pointer';
			modal.style.flexDirection = 'column';

			// Create the iframe element
			const modalIframe = document.createElement('iframe');
			modalIframe.src = src;
			modalIframe.style.width = '90%';
			modalIframe.style.height = '90%';
			modalIframe.style.border = 'none';

			// Append the iframe to the modal
			modal.appendChild(modalIframe);

			// create exit button
			const exitButton = document.createElement('button');
			exitButton.textContent = 'Exit';
			exitButton.style.background = '#fff';
			exitButton.style.padding = '5px 10px';
			exitButton.style.fontWeight = '40';
			exitButton.style.color = '#000';
			exitButton.style.border = 'none';
			exitButton.style.cursor = 'pointer';
			exitButton.style.fontSize = '16px';
			exitButton.style.zIndex = '1000';
			exitButton.style.borderRadius = '10%';
			exitButton.style.display = 'block';
			exitButton.style.marginTop = '10px';
			exitButton.style.marginLeft = 'auto';
			exitButton.style.marginRight = 'auto';
			// Append the button to the modal
			modal.appendChild(exitButton);

			// Append the modal to the body
			document.body.appendChild(modal);

			// Remove modal on click
			modal.addEventListener('click', function () {
				document.body.removeChild(modal);
			});
		} else {
			const modal = document.createElement('div');
			modal.id = 'modal';
			modal.style.zIndex = '1000';
			modal.style.position = 'fixed';
			modal.style.top = '0';
			modal.style.left = '0';
			modal.style.width = '100%';
			modal.style.height = '100%';
			modal.style.background = 'rgba(0,0,0,0.8)';
			modal.style.display = 'flex';
			modal.style.alignItems = 'center';
			modal.style.justifyContent = 'center';
			modal.style.cursor = 'pointer';
			modal.style.flexDirection = 'column';

			// Create the image element
			const modalImg = document.createElement('img');
			modalImg.src = src;
			modalImg.style.maxWidth = '90%';
			modalImg.style.maxHeight = '90%';

			modal.appendChild(modalImg);
			// create exit button
			const exitButton = document.createElement('button');
			exitButton.textContent = 'Exit';
			exitButton.style.background = '#fff';
			exitButton.style.padding = '5px 10px';
			exitButton.style.fontWeight = '40';
			exitButton.style.color = '#000';
			exitButton.style.border = 'none';
			exitButton.style.cursor = 'pointer';
			exitButton.style.fontSize = '16px';
			exitButton.style.zIndex = '1000';
			exitButton.style.borderRadius = '10%';
			exitButton.style.display = 'block';
			exitButton.style.marginTop = '10px';
			exitButton.style.marginLeft = 'auto';
			exitButton.style.marginRight = 'auto';
			// Append the button to the modal
			modal.appendChild(exitButton);

			// Append the modal to the body
			document.body.appendChild(modal);

			modal.addEventListener('click', function () {
				document.body.removeChild(modal);
			});
			// Remove modal on click
		}
	};

	formatAmount = (amount, colName) => {
		if (colName === 'annual_rate') {
			return `${parseFloat(amount).toFixed(2)}%`;
		} else {
			let value = parseFloat(amount).toFixed(2);
			let num = value.toString().replace(/(\s)/g, '');
			num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return `${num}`;
		}
	};

	getParamStatus = () => {
		const { status, page, tab } = qs.parse(window.location.search);

		return { status, page, tab };
	};

	setFundingSourceDetails = async queryUrl => {
		const { status, page, tab } = this.getParamStatus();
		let updateQuery;
		if (status && page && tab) {
			updateQuery = {
				...qs.parse(queryUrl),
				page,
				tab,
				state: status
			};
			updateQuery = `?${qs.stringify(updateQuery)}`;
		} else {
			updateQuery = queryUrl;
		}

		return LoanService.getUserLoansByUserId(this.props.match.params.id, updateQuery);
	};

	componentDidUpdate(prevProps) {
		if (prevProps.status !== this.props.status) {
			this.setState({
				_customFilterQuery:
					this.props.status == 'ALL'
						? `state=PENDING,DECLINE,APPROVE,POST_MODIFIED,PRE_MODIFIED,PAYMENTS_STOPED,DELETED,COMPLETED`
						: this.props.status == 'ACCEPTED'
						? `state=APPROVE`
						: this.props.status == 'MODIFIED'
						? `state=POST_MODIFIED,PRE_MODIFIED`
						: this.props.status == 'PAUSED'
						? `state=PAYMENTS_STOPED`
						: `state=${this.props.status}`
			});
		}
	}

	getPageTabNumbers = () => {
		const { page, tab } = qs.parse(window.location.search);
		return { page, tab };
	};

	render() {
		const dayjs = require('dayjs');
		const amountColOpts = {
			sort: true,
			customBodyRender: (value, tableMeta) => {
				const colName = columns[tableMeta.columnIndex].name;
				return <span className="bold-important">{this.formatAmount(value, colName)}</span>;
			}
		};
		const columns = [
			{
				name: 'creation_date',
				label: 'Date/Time',
				options: {
					sort: true,
					customBodyRender: value => {
						return (
							<span className="bold-important">{value ? convertToPhilippinesTime(value) : 'N/A'}</span>
						);
					}
				}
			},
			{
				name: 'id',
				label: 'Loan ID',
				options: {
					sort: true,
					customBodyRender: value => {
						return this.props.match.path === '/admin/customer/custom-view/:id' ? (
							<span className="bold-important">{`LA${String(value).padStart(5, '0')}`}</span>
						) : (
							<a
								href={`/admin/loans/${value}`}
								// eslint-disable-next-line react/jsx-no-target-blank
								target="_blank">
								<span className="bold-important">{`LA${String(value).padStart(5, '0')}`}</span>
							</a>
						);
					}
				}
			},
			{
				name: 'loan_type',
				label: 'Loan Type',
				options: {
					sort: true,
					customBodyRender: value => {
						const name =
							value === 'LEND' ? 'badge badge-pill badge-primary' : 'badge badge-pill badge-warning';
						if (value !== undefined) {
							return <span className={name}>{value}</span>;
						}
					}
				}
			},
			{
				name: 'creator_name',
				label: 'From',
				options: {
					sort: true,
					customBodyRender: value => {
						return value || 'N/A';
					}
				}
			},
			{
				name: 'acceptor_name',
				label: 'To',
				options: {
					sort: true,
					customBodyRender: (value, tableMeta) => {
						return value || tableMeta.rowData[13] || 'N/A';
					}
				}
			},
			{
				name: 'state',
				label: 'Status',
				options: {
					sort: true,
					customBodyRender: value => {
						if (value === 'PAYMENTS_STOPED') {
							return 'PAUSED';
						} else if (value === 'POST_MODIFIED' || value === 'PRE_MODIFIED') {
							return 'MODIFIED';
						} else if (value === 'APPROVE') {
							return 'APPROVED';
						} else if (value === 'DECLINE') {
							return 'DECLINED';
						} else {
							return value || 'N/A';
						}
					}
				}
			},
			{
				name: 'principal',
				label: 'Loan Amount(₱)',
				options: amountColOpts
			},
			{
				name: 'collateral_image',
				label: 'Collateral',
				options: {
					sort: true,
					customBodyRender: value => {
						if (!value) return 'No Image or PDF attached.';

						return value.includes('.pdf') ? (
							<span
								style={{
									color: 'blue',
									cursor: 'pointer'
								}}
								onClick={this.handleClick.bind(this, {
									src: value
								})}>
								View PDF
							</span>
						) : (
							<span
								style={{
									color: 'blue',
									cursor: 'pointer'
								}}
								onClick={this.handleClick.bind(this, {
									src: value
								})}>
								View Image
							</span>
						);
					}
				}
			},
			{
				name: 'annual_rate',
				label: 'Interest Rate(%)',
				options: amountColOpts
			},
			{
				name: 'total',
				label: 'Total Payable Amount(₱)',
				options: amountColOpts
			},
			{
				name: 'overdue_amount',
				label: 'Overdue Amount(₱)',
				options: amountColOpts
			},
			{
				name: 'paid_amount',
				label: 'Paid Amount(₱)',
				options: amountColOpts
			}
		];

		const viewCol = [
			...columns,
			{
				name: 'id',
				label: 'Action',
				options: {
					sort: true,
					customBodyRender: (value, tableMeta) => {
						return (
							<a
								href={`/admin/customer/review/loan/${value}?creator_name=${
									tableMeta.rowData[3]
								}&acceptor_name=${tableMeta.rowData[4] || tableMeta.rowData[13]}&mode_payment=${
									tableMeta.rowData[14] || tableMeta.rowData[15]
								}&userId=${this.props.match.params.id}&status=${tableMeta.rowData[5]}&page=${
									this.getPageTabNumbers().page
								}&tab=${this.getPageTabNumbers().tab}`}>
								Review
							</a>
						);
					}
				}
			},
			{
				name: 'invite_name',
				label: 'Invite Name',
				options: {
					display: 'excluded'
				}
			},
			{
				name: 'disbursal_mode',
				label: 'disburasal Mode',
				options: {
					display: 'excluded'
				}
			},
			{
				name: 'latest_disbursal_mode',
				label: 'disburasal Mode',
				options: {
					display: 'excluded'
				}
			}
		];

		return (
			<>
				<Table
					columns={
						this.props.match.path === '/admin/customer/custom-view/:id' ||
						this.props.match.path === '/admin/transactions'
							? viewCol
							: columns
					}
					customFilterQuery={this.state._customFilterQuery}
					dataSourceHandler={this.setFundingSourceDetails}
					dataSourceName="loans"
					sort
					title="Loan list"
					status={this.props.status}
				/>
			</>
		);
	}
}

export default withRouter(hot(module)(Loans));
